import { Injectable, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/app/environment';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import AlertifyHelper from './utils';
import Swal from 'sweetalert2';
import { GlobalService } from '../api/global.service';

@Injectable({
  providedIn: 'root'
})
export default class RestService  {
  public baseApiUrl:string;

  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
    private alertifyMsg: AlertifyHelper
  ) {
      const currentUrl = localStorage.getItem('slugBranchoffice');
      this.baseApiUrl = "/"+currentUrl+this.globalService.domainApi;
  }

  all(url: any, params: string = ''): Observable<any> {
    this.showloader();
    return (
      this.http
        .get(this.baseApiUrl + url + params)
        // .pipe(tap(res => this.hideloader()), catchError(this.handleError.bind(this)))
        // .pipe(catchError(this.handleError.bind(this)))
        .pipe(
          finalize(() => this.hideloader()),
          catchError(this.handleError.bind(this))
        )
    );
  }

  // get(url: any, val_id:number): Observable<any> {
  //   this.showloader();
  //   return (
  //     this.http
  //       .get(this.baseApiUrl + url + '/' + val_id)
  //       // .pipe(tap(res => this.hideloader()), catchError(this.handleError.bind(this)))
  //       // .pipe(catchError(this.handleError.bind(this)))
  //       .pipe(
  //         finalize(() => this.hideloader()),
  //         catchError(this.handleError.bind(this))
  //       )
  //   );
  // }

  get(url: any, val_id: number): Observable<any> {
    this.showloader();
    return this.http.get(this.baseApiUrl + url + '/' + val_id).pipe(
      catchError(this.handleError.bind(this)),
      finalize(() => this.hideloader()) // Oculta el loader después de recibir datos
    );
  }

  update(url: any, val_id:number, data: any): Observable<any> {
    this.showloader();
    return (
      this.http
        .put(this.baseApiUrl + url + '/' + val_id, data)
        .pipe(
          finalize(() => this.hideloader()),
          catchError(this.handleError.bind(this))
        )
    );
  }

  save(url: any, data: any): Observable<any> {
    this.showloader();
    return (
      this.http
        .post(this.baseApiUrl + url, data)
        // .pipe(tap(res => this.hideloader()), catchError(this.handleError.bind(this)))
        // .pipe(catchError(this.handleError.bind(this)))
        .pipe(
          finalize(() => this.hideloader()),
          catchError(this.handleError.bind(this))
        )
    );
  }  

  delete(url: any, val_id:number): Observable<any> {
    this.showloader();
    return (
      this.http
        .delete(this.baseApiUrl + url + '/' + val_id)
        .pipe(
          finalize(() => this.hideloader()),
          catchError(this.handleError.bind(this))
        )
    );
  }

  showloader() {
    (<HTMLInputElement>document.getElementById('loading')).style.display = 'block';
  }

  hideloader() {
    // setTimeout(() => {
    //   (<HTMLInputElement>document.getElementById("loading")).style.display = 'none';
    // }, 2000);
    (<HTMLInputElement>document.getElementById('loading')).style.display =
      'none';
      const elements = document.getElementsByClassName('content_loading');
      Array.from(elements).forEach((element) => {
          (element as HTMLElement).style.display = 'none';
      });
  }

  handleError(error: any) {
    // console.log(error);
    this.hideloader();
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;      
    } else {
      // server-side error
      // errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      console.log(error);
      console.log(error.code);
      if(error.status == 400){
        if(error.error.code == 100){
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
        }else{
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.error}`;
        }        
      }else{
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
      }
    }
    // console.log(errorMessage);
    // this.alertifyMsg.error(errorMessage);    
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error',
        text: errorMessage
      });
    return throwError(() => new Error(errorMessage));
  }

  //   all() {
  //     this.http
  //       .get('https://api.escuelajs.co/api/v1/products/?offset=10&limit=5')
  //       .subscribe({
  //         next: (data: any) => {
  //           // console.log(data);
  //         },
  //         complete: () => {}, // completeHandler

  //         error: (error) => {
  //           console.log(error);
  //         },
  //       });
  //   }
}